<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DqSNBU/9780316233217.jpg?1733067619701" alt="This image is the cover for the book Only Human"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Only Human
      </h1>
      <p class="bookDescription body article font2">
        <p>Something is about to go wrong. Very wrong. What do you expect if the Supreme Being decides to get away from it all for a few days, leaving his naturally inquisitive son to look after the cosmic balance of things? A minor hiccup with a human soul and a welding machine soon leads to a violent belch, and before you know it the human condition-not to mention the lemming condition-is tumbling down the slippery slope to chaos.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Holt
      </h2>
      
      <p class="authorDescription body article"><B>Tom Holt</B> was born in London in 1961. At Oxford he studied bar billiards, ancient Greek agriculture and the care and feeding of small, temperamental Japanese motorcycle engines; interests which led him, perhaps inevitably, to qualify as a solicitor and emigrate to Somerset, where he specialized in death and taxes for seven years before going straight in 1995. He lives in Chard, Somerset, with his wife and daughter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e91ce32